import { render, staticRenderFns } from "./searchAttr.vue?vue&type=template&id=47ca16e2&scoped=true"
import script from "./searchAttr.vue?vue&type=script&lang=js"
export * from "./searchAttr.vue?vue&type=script&lang=js"
import style0 from "./searchAttr.vue?vue&type=style&index=0&id=47ca16e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca16e2",
  null
  
)

component.options.__file = "searchAttr.vue"
export default component.exports